module.exports = __webpack_public_path__ + "static/img/sec3-content02-img02@m.a647d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ybTour/sec3-content02-img02@m.jpg
// module id = CDcL
// module chunks = 0